import { getSelectedViewType } from './getSelectedViewType';
import { CalendarViewTypeEnum } from 'owa-calendar-view-type';

export function isCanvasViewTypeSelected(): boolean {
    return getSelectedViewType() === CalendarViewTypeEnum.Canvas;
}
